import React, { Component } from 'react';
import { Typography, Table, Row, Button, Divider, Input, Spin, Tag, Badge, Collapse, Popconfirm, Select, message, Drawer, notification, Tooltip } from 'antd';
import { Link, Switch, Route } from 'react-router-dom';
import moment from 'moment';
import { defaultDateFormat, showErrorInNotification, THEME_COLORS, overrideHeaderBack, overrideHeaderTitle, formatMoney } from '../../lib/util';
import { RESTExecutor, withDomains } from '../../lib/domain';
import ErrorWrapper from '../../lib/error_wrapper';
import CustomDateRangePicker from '../../components/custom_date_range';
import { PopUpForm } from '../../lib/ui/popupform';
import FilesTransactions from './file_transactions';
import { BasicHeader } from '../../components/basic_header';
import FilterFixedInput from '../../components/filter_fixed_input';
import { TransparentButton } from '../../components/basic_items';
import { CloudUploadOutlined, GetAppOutlined, LayersOutlined, FlipOutlined, WifiTetheringOutlined, CloudDownloadOutlined, Refresh, AssignmentReturn, DnsOutlined, StorageOutlined, VisibilityOutlined } from '@material-ui/icons';
import { COLORS } from '../theme';
import ExternalFilterClear from '../../components/external_filter_clear';


const { Panel } = Collapse;
const { Title, Paragraph, Text } = Typography;
const queryString = require('query-string');
const customPanelStyle = {
  background: '#FFFFFF',
  borderRadius: 6,
  marginBottom: 12,
  border: 0,
  overflow: 'hidden',
};

const aggregated_cols = ({ datatype, onReprocessFile, onDownload, reprocessed_list = [] }) => [
  {
    title: "Created At",
    dataIndex: 'created_at',
    key: 'created_at',
    width: 170,
  },
  {
    title: "File",
    dataIndex: 'file_uri',
    key: 'file_uri',
    className: 'word-break',
    // width: 200,
    render: (file_name, record) => {
      let has_run = record.file_processed == false || (record.file_processed == true && record.error == true);
      return <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      }}>
        {file_name ?file_name :
          !record.data_type_processed ? <span>Selector not applied yet</span> :
            record.error == true && record.selector_success == false ? <span>Error while Applying Selector</span> :
              <span>No File Extracted</span>}
        {/* <span>{file_name || "No File Extracted"}</span> */}

        {has_run && !reprocessed_list.includes(record.id) && <Popconfirm
          onConfirm={() => {
            // this.loading_message = message.loading(`Reprocessing ${file_name}`, 0);
            // this.setState({
            //   reprocessing_id: record.id
            // })
            // this.reprocess_file.config({
            //   params: {
            //     response_id: record.fetcher_response_id,
            //     file_id: record.id
            //   }
            // }).execute();
            typeof onReprocessFile === 'function' && onReprocessFile(record)
          }}
          title="Are you sure you want to run this file?">
          <Refresh className='hand-cursor'
            titleAccess="Rerun"
            style={{
              height: 20,
              color: COLORS.primary,
              width: 20,
              // border:'1px solid',
              // borderRadius:'50%',
              marginLeft: 8
            }} /></Popconfirm>}

      </div>
    }

  },
  {
    dataIndex:'file_uri',
    width:40,
    align:'center',
    render:(file_name,record)=>{
      if(file_name){
        return <Link style={{
          display: 'flex',
          alignItems: 'center'
        }} to={`/activity/data-type/${record.data_type_id}/files/${record.id}/view`}>
          <VisibilityOutlined/>
          </Link>
      }else{
        return <div></div>
      }
    }
  },
  {
    title: "Pipeline ",
    className: 'pipeline-cols',
    children: [
      {
        title: "Blocks",
        width: 100,
        key: 'blocks_count',
        dataIndex: 'blocks_count',
        className: 'pipeline-cols center-align',
        render: (success_count = 0, record) => record.data_type_processed == false ? <span className='right-align'>-</span> :
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>{record.file_processed == false && success_count > 0 ? <Link to={{
            pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
            search: queryString.stringify({
              // success_type:1
            })
          }}>
            <span className='right-align'>{formatMoney(success_count, 0)}</span>
          </Link> :
            <span className='right-align'>{formatMoney(success_count, 0)}</span>
            }</div>
      },
      {
        title: "Parser",
        width: 100,
        key: 'Parser',
        className: 'pipeline-cols center-align',
        render: (record) => {
          let success_count = record.parsing_success;
          let error_count = record.parsing_error;
          let obj = {
            children: record.data_type_processed == false || record.selector_success == false || (record.file_processed == false || (record.file_processed == true && record.processing_error == true)) ? <span className='right-align'>-</span> : <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              {record.file_processed == false || (record.file_processed == true && record.error == true) ?
                error_count > 0 ? <Link to={{
                  pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                  search: queryString.stringify({
                    status: 'error',
                    error_type: 1
                  })
                }}>
                  <span className='error-text'>{formatMoney(success_count, 0)} (-{formatMoney(error_count, 0)})</span>
                </Link> :

                  <Link to={{

                    pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                    search: queryString.stringify({
                      success_type: 1
                    })
                  }}>
                    <span className='right-align'>{formatMoney(success_count, 0)}</span>
                  </Link> :
                <span className='right-align'>{formatMoney(success_count, 0)}</span>
              }
            </div>,
            props: {
              className: record.data_type_processed == false || record.selector_success == false || (record.file_processed == false || (record.file_processed == true && record.processing_error == true)) ? '' : error_count > 0 ? 'pipeline-error-cell' : 'pipeline-success-cell'
            }
          }
          return obj;
        }
      },
      {
        title: "Normalizer",
        width: 100,
        key: 'Normalizer',
        className: 'pipeline-cols center-align',
        render: (record) => {
          let success_count = record.normalization_success;
          let error_count = record.normalization_error;
          let obj = {
            children: record.data_type_processed == false || record.selector_success == false || (record.file_processed == false || (record.file_processed == true && record.processing_error == true)) ? <span className='right-align'>-</span> : <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              {record.file_processed == false || (record.file_processed == true && record.error == true) ?
                error_count > 0 ? <Link to={{
                  pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                  search: queryString.stringify({
                    status: 'error',
                    error_type: 2
                  })
                }}>
                  <span className='error-text'>{formatMoney(success_count, 0)} (-{formatMoney(error_count, 0)})</span>
                </Link> :

                  <Link to={{

                    pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                    search: queryString.stringify({
                      success_type: 2
                    })
                  }}>
                    <span className='right-align'>{formatMoney(success_count, 0)}</span>
                  </Link> :
                <span className='right-align'>{formatMoney(success_count, 0)}</span>
              }
            </div>,
            props: {
              className: record.data_type_processed == false || record.selector_success == false || (record.file_processed == false || (record.file_processed == true && record.processing_error == true)) ? '' : error_count > 0 ? 'pipeline-error-cell' : 'pipeline-success-cell'
            }
          }
          return obj
        }

      },
    ]
  },
  {
    title: "Packets",
    children: [
      {
        title: "Queued",
        width: 70,
        key: 'queued_packets',
        dataIndex: 'queued_packets',
        className: 'center-align',
        render: (value, record) => <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>{record.data_type_processed == false ? <span className='right-align'>-</span> : value > 0 ? <Link to={{
          pathname: `/activity/data-type/${record.data_type_id}/packets`,
          search: queryString.stringify({
            transferred: 'false',
            fetcher_response_id: record.fetcher_response_id
          })
        }}> <span className='right-align'>{formatMoney(value, 0)}</span></Link> : <span className='right-align'>{formatMoney(value, 0)}</span>
          }</div>
      },
      {
        title: "Transferred",
        width: 95,
        key: 'transferred_packets',
        dataIndex: 'transferred_packets',
        className: 'center-align',
        render: (value, record) => <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>{record.data_type_processed == false ? <span className='right-align'>-</span> : value > 0 ? <Link to={{
          pathname: `/activity/data-type/${record.data_type_id}/packets`,
          search: queryString.stringify({
            transferred: 'true',
            fetcher_response_id: record.fetcher_response_id
          })
        }}> <span className='right-align'>{formatMoney(value, 0)}</span></Link> : <span className='right-align'>{formatMoney(value, 0)}</span>
          }</div>

      },
      {
        title: "Total",
        width: 60,
        key: 'total_packets',
        dataIndex: 'total_packets',
        className: 'center-align',
        render: (value, record) => <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>{record.data_type_processed == false ? <span className='right-align'>-</span> :
          value > 0 ? <Link to={{
            pathname: `/activity/data-type/${record.data_type_id}/packets`,
            search: queryString.stringify({
              fetcher_response_id: record.fetcher_response_id
            })
          }}>  <span className='right-align'>{formatMoney(value, 0)}</span></Link> : <span className='right-align'>{formatMoney(value, 0)}</span>
          }</div>
      }
    ]
  },
  // {
  //   title: "File",
  //   dataIndex: 'file_uri',
  //   key: 'file_uri',
  // },
  // {
  //   title: "Packets Count",
  //   dataIndex: 'packets_count',
  //   key: 'packets_count',
  //   width:100,
  //   className:'right-align',
  //   render: (value, record) => {
  //     return value?<Link className='right-flex-child' to={{
  //       pathname:`/activity/data-type/${datatype}/packets`,
  //       search:queryString.stringify({
  //         fetcher_response_id:record.fetcher_response_id,
  //         file_uri:record.file_uri,
  //         // dateFrom:moment(record.created_at,"YYYY-MM-DD HH:mm:ss A").isValid()?moment(record.created_at,"YYYY-MM-DD").format("YYYY-MM-DD"):null,
  //         // dateTo:moment(record.created_at,"YYYY-MM-DD HH:mm:ss A").isValid()?moment(record.created_at,"YYYY-MM-DD").add({day:1}).format("YYYY-MM-DD"):null,

  //       })
  //     }}>{formatMoney(value,0)}</Link>:(value||"-")
  //   }
  // },
  // {
  //   title: "Blocks Count",
  //   dataIndex: 'blocks_count',
  //   key: 'blocks_count',
  //   width:100,
  //   render: (value, record) => {
  //   return <div style={{
  //     display:'flex',
  //     flexDirection:'column',
  //     alignItems:'flex-end'
  //   }}>
  //     {record.failed_count? <Link  to={{
  //       pathname:`/activity/data-type/${datatype}/files/${record.id}`,
  //     }}>
  //       <span className='right-align'>{formatMoney(value,0)}</span>
  //     </Link>:
  //     <span className='right-align'>{formatMoney(value,0)}</span>
  //   }
  //     {record.failed_count>0&&
  //     <Link  to={{
  //       pathname:`/activity/data-type/${datatype}/files/${record.id}`,
  //       search:queryString.stringify({
  //         status:'error'
  //       })
  //     }}>
  //     <span className='error-text'>{formatMoney(record.failed_count,0)} Failed</span>
  //   </Link>}</div>
  //   }
  // },

  {
    title: "Actions",
    key: 'actions',
    className: 'center-align',
    width: 100,
    render: (record, data) => {
      return <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: 16,
        paddingRight: 16,
        justifyContent: 'center'
      }}>
        <GetAppOutlined titleAccess="Download File"
          onClick={() => {
            typeof onDownload === 'function' && onDownload(record)
          }}
          className='basic-icon hand-cursor' />
        <Divider type='vertical' />
        <Link to={{
          pathname: `/activity/fetcher/responses/${record.fetcher_log_id}/${record.fetcher_response_id}`,
          // search: queryString.stringify({
          //   file_uri: record.file_uri,
          //   fetcher_response_id: record.fetcher_response_id,
          //   data_selector_id: record.data_selector_id
          // })
        }}>
          <DnsOutlined
            titleAccess='Go To Response'
            className='basic-icon hand-cursor'
          // onClick={() => {
          //     console.log("detail clicked")
          //     typeof onViewclicked === 'function' && onViewclicked(id)
          // }} 
          /></Link>

        {/* <Link to={{
        pathname:`/activity/data-type/${datatype}/files/${record.id}/view`}}
        >
        <Button title="View File"
          onClick={() => {
          }}
          style={{
            padding: 0
          }} type='link'>View</Button>
          </Link>
        <Divider type='vertical' /> */}

        {/* <Button title="Rerun"
        disabled={record.processed}
          onClick={() => {
            if(record.processed){
              notification.warn({
                message:"You cannot re-run this file now."
              })
            }else{
              typeof onReprocess==='function'&&onReprocess(record)
            }
          }}
          style={{
            padding: 0
          }} type='link'>Re-run</Button>
       */}

      </div>
    }
  }
]

class FileList extends Component {
  constructor(props) {
    super(props)

    this.datatype = props.match.params.datatype_id;

    this.state = {
      filter_query: {
        per_page: 100,
        page: 1,
        // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
        // dateTo: moment().format(defaultDateFormat),
      },
      datatype: this.datatype,
      datatype_obj: {},
      form_data: {},
      form_visibility: false,

      upload_form_visibility: false,
      loading: true,
      reprocessed_file_ids: [],
      reprocessing_id: null
    };

    this.datatype_detail = RESTExecutor.detail().config({
      label: 'datatypes_details'
    }).callbacks((success) => {
      this.setState({ loading: false, datatype_obj: success.result })
      this.list_files.forId(this.datatype).config({
        params: {
          ...this.state.filter_query
        }
      }).execute();
    }, (error) => {
      showErrorInNotification(error);
      this.setState({ loading: false })
    }).forId(this.state.datatype).connect(props.domains.allData)


    this.list_files = RESTExecutor.list().config({
      label: 'file_list',
      params: {
        ...this.state.filter_query
      }
    }).forId(this.state.datatype).connect(props.domains.activity);



    this.reprocess_file = RESTExecutor.post().config({
      label: 'file_reprocess',
      params: {}
    }).callbacks((success) => {
      try {
        this.loading_message();
      } catch (e) {

      }
      let reprocessing_id = this.state.reprocessing_id;
      let new_reprocessed_file_ids = this.state.reprocessed_file_ids;
      new_reprocessed_file_ids.push(reprocessing_id);
      this.setState({
        reprocessed_file_ids: new_reprocessed_file_ids,
        reprocessing_id: null
      })
      message.success(success.result.message || "Reprocessing File");
    }, (error) => {
      try {
        this.loading_message();
      } catch (e) {

      }
      showErrorInNotification(error);
      this.setState({
        reprocessing_id: null
      })
    }).connect(props.domains.activity);

    this.get_file_url = RESTExecutor.detail().config({
      label: 'file_download',
      params: {}
    }).callbacks((success) => {

      window.open(success.result.url, '_blank');
      try {
        this.loading_message();
      } catch (e) {

      }

    }, (error) => {
      showErrorInNotification(error);
      try {
        this.loading_message();
      } catch (e) { }

    }).connect(props.domains.activity);


    // this.list_files.execute();


  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }


  render() {
    let list_files_resp = this.list_files.response();// this.list_datatypes.response();
    let list_files_data = list_files_resp.result || {};
    let datatype_detaile_resp = this.datatype_detail.response()

    if (this.state.loading) {
      return <center><Spin /></center>
    }
    let rowsData = list_files_data.rows || [];
    let rowsMeta = list_files_resp.meta || {};


    console.log("rows meta", rowsMeta)


    const { filter_query, reprocessed_file_ids, reprocessing_id } = this.state;



    return (
      <ErrorWrapper
        error={datatype_detaile_resp}
        onReload={() => {
          this.datatype_detail.execute()
        }}
      >


        <BasicHeader
          title={this.state.datatype_obj.name}
          titleType="Datatype"
          subtitle="Files"
          right={[
            <Link to={`/activity/data-type/${this.datatype}/transactions`} >
              <TransparentButton
                label="Transactions"
                icon={<StorageOutlined />}
                hint="View Transactions"
              />
            </Link>,
            <Link to={`/activity/data-type/${this.datatype}/packets`} >
              <TransparentButton
                label="Packets"
                icon={<LayersOutlined />}
                hint="View Packets"
              />
            </Link>,
            <Link to={`/activity/data-type/${this.datatype}/sources`} >
              <TransparentButton
                label="Sources"
                icon={<WifiTetheringOutlined />}
                hint="View Sources"
              />
            </Link>
            // <Button type='primary' onClick={() => {
            //   this.setState({
            //     upload_form_visibility: true
            //   })
            // }} style={{ margin: 4 }} icon='file' key="3">Upload File</Button>
          ]}
        />



        <ErrorWrapper
          error={list_files_resp}
          onReload={() => {
            this.list_files.execute()
          }}
        >
          <div className='filter-card'>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              // justifyContent: 'space-between',
              // flexWrap: 'nowrap',
              paddingTop: 4, paddingBottom: 4,
              // paddingLeft: 8, paddingRight: 8
            }}>
              <FilterFixedInput label="Date Range">
                <CustomDateRangePicker
                  style={{
                    // margin: 4,
                    // width: 400
                  }}
                  startDate={filter_query.dateFrom ? moment(filter_query.dateFrom, defaultDateFormat) : null}
                  endDate={filter_query.dateTo ? moment(filter_query.dateTo, defaultDateFormat) : null}
                  onChange={(dates) => {
                    //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                    this.stateUpdater({
                      stateKey: 'filter_query', appendObj: {
                        dateFrom: dates.startDate.format(defaultDateFormat),
                        dateTo: dates.endDate.format(defaultDateFormat)
                      },
                      callback: () => {
                        this.props.history.push({
                          search: queryString.stringify({ ...this.state.filter_query, page: 1 })
                        })
                      }
                    });
                  }}
                />
              </FilterFixedInput>
            </div>
          </div>
          <ExternalFilterClear
            filters={filter_query}
            staticKeys={['dateFrom', 'dateTo']}
            onClear={(new_filters) => {
              this.props.history.push({
                search: queryString.stringify(new_filters)
              })
            }}
          />
          <div className='default-card' style={{
            // padding: 8
          }}>
            <Table
              // rowClassName='hand-cursor'
              className='main-table noHover padder'
              loading={list_files_resp.fetching}
              size='small'
              scroll={{ x: true }}
              pagination={{
                // simple: true,
                position: 'bottom',
                onChange: (current, size) => {
                  this.props.history.push({
                    search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                  })
                },
                defaultCurrent: 1,
                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                defaultPageSize: 100,
                pageSize: (rowsMeta && rowsMeta.requested_count),

                total: (rowsMeta && rowsMeta.total_count > 10000 ? 10000 : rowsMeta.total_count),
                showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${rowsMeta.total_count > 10000 ? `10,000+` : formatMoney(rowsMeta.total_count, 0)} items`
              }}
              bordered={true}
              rowKey={(record) => record.parse_batch_id}
              columns={aggregated_cols({
                datatype: this.datatype,
                onReprocessFile: (record) => {
                  this.loading_message = message.loading(`Reprocessing ${record.file_uri}`, 0);
                  this.setState({
                    reprocessing_id: record.id
                  })
                  this.reprocess_file.config({
                    params: {
                      response_id: record.fetcher_response_id,
                      file_id: record.id
                    }
                  }).execute();
                },
                onDownload: (record) => {
                  this.loading_message = message.loading(`Downloading ${record.file_uri}`, 0);
                  this.get_file_url.forId(this.datatype).config({
                    params: {
                      file_id: record.id,
                      attachment: true
                    }
                  }).execute();
                },
                reprocessed_list: [...reprocessed_file_ids, reprocessing_id]
              })}
              dataSource={rowsData}
            />
          </div>
        </ErrorWrapper>
      </ErrorWrapper>
    );
  }

  componentDidMount() {

    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
        // dateTo: moment().format(defaultDateFormat),
        ...new_filter_query
      }
    }, () => {
      this.datatype_detail.execute()
      // this.list_packets.config({
      //     params: {
      //     ...this.state.filter_query
      //     }
      // }).execute()
    })
  }

  componentWillUnmount() {
    try {
      this.loading_message();
    } catch (e) {

    }
  }
  componentWillReceiveProps(nextProps) {
    var olddatatype_id = this.props.match.params.datatype_id;
    var newdatatype_id = nextProps.match.params.datatype_id;


    if (olddatatype_id !== newdatatype_id || (
      this.props.location && (this.props.location.search !== nextProps.location.search)
    )) {
      this.datatype = newdatatype_id;
      const parsed = queryString.parse(nextProps.location.search);
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
          // dateTo: moment().format(defaultDateFormat),
          ...parsed
        },
      }, () => {
        if (olddatatype_id !== newdatatype_id) {
          this.setState({
            loading: true
          }, () => {
            this.datatype_detail.forId(this.datatype).execute()
          })
        } else {
          this.list_files.forId(this.datatype).config({
            params: {
              ...this.state.filter_query
            }
          }).execute()
        }
      })

    }
  }
}

export default FileList = withDomains(FileList, "activity", "allData", "datatype");

